/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GenerateBackgroundImageRequest,
  PaginatedPlaylistBackgroundImageList,
  PlaylistBackgroundImage,
  PlaylistBackgroundImageBulkDeleteRequest,
  PlaylistBackgroundImageReorderRequest,
  PlaylistBackgroundImageRequest,
  PlaylistBackgroundImagesParams,
  SaveGeneratedBackgroundImageRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 플레이리스트의 모든 배경 이미지를 순서대로 조회합니다.
 * @summary 배경 이미지 목록 조회
 */
export const playlistBackgroundImages = (
  playlistPk: string,
  params?: PlaylistBackgroundImagesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedPlaylistBackgroundImageList>(
    {
      url: `/api/playlists/${playlistPk}/background-images/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistBackgroundImagesQueryKey = (
  playlistPk?: string,
  params?: PlaylistBackgroundImagesParams,
) => {
  return [
    `/api/playlists/${playlistPk}/background-images/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlaylistBackgroundImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistBackgroundImages>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistBackgroundImagesQueryKey(playlistPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistBackgroundImages>>
  > = ({ signal }) =>
    playlistBackgroundImages(playlistPk, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!playlistPk,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistBackgroundImages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistBackgroundImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundImages>>
>;
export type PlaylistBackgroundImagesQueryError = ErrorType<unknown>;

export function usePlaylistBackgroundImages<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params: undefined | PlaylistBackgroundImagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundImages>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundImages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundImages<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundImages>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundImages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundImages<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 배경 이미지 목록 조회
 */

export function usePlaylistBackgroundImages<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistBackgroundImagesQueryOptions(
    playlistPk,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트에 배경 이미지를 업로드합니다.

**자동 최적화:**
- 2560x1440 (16:9) WebP로 자동 리사이즈
- 비율이 다른 이미지는 중앙 크롭 후 리사이즈
- 320x180 썸네일 자동 생성

**지원 형식:** JPEG, PNG, WebP (최대 10MB)
 * @summary 배경 이미지 업로드
 */
export const playlistBackgroundImages2 = (
  playlistPk: string,
  playlistBackgroundImageRequest: BodyType<PlaylistBackgroundImageRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundImageRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistBackgroundImages2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBackgroundImages2>>,
    TError,
    { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBackgroundImages2>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
  TContext
> => {
  const mutationKey = ["playlistBackgroundImages2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBackgroundImages2>>,
    { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistBackgroundImages2(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBackgroundImages2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundImages2>>
>;
export type PlaylistBackgroundImages2MutationBody =
  BodyType<PlaylistBackgroundImageRequest>;
export type PlaylistBackgroundImages2MutationError = ErrorType<unknown>;

/**
 * @summary 배경 이미지 업로드
 */
export const usePlaylistBackgroundImages2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBackgroundImages2>>,
      TError,
      { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBackgroundImages2>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistBackgroundImages2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 배경 이미지의 상세 정보를 조회합니다.
 * @summary 배경 이미지 상세 조회
 */
export const playlistBackgroundImages4 = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/${id}/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistBackgroundImages4QueryKey = (
  playlistPk?: string,
  id?: string,
) => {
  return [`/api/playlists/${playlistPk}/background-images/${id}/`] as const;
};

export const getPlaylistBackgroundImages4QueryOptions = <
  TData = Awaited<ReturnType<typeof playlistBackgroundImages4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistBackgroundImages4QueryKey(playlistPk, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistBackgroundImages4>>
  > = ({ signal }) =>
    playlistBackgroundImages4(playlistPk, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(playlistPk && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistBackgroundImages4>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistBackgroundImages4QueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundImages4>>
>;
export type PlaylistBackgroundImages4QueryError = ErrorType<unknown>;

export function usePlaylistBackgroundImages4<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages4>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundImages4>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundImages4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundImages4<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages4>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundImages4>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundImages4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundImages4<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 배경 이미지 상세 조회
 */

export function usePlaylistBackgroundImages4<
  TData = Awaited<ReturnType<typeof playlistBackgroundImages4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundImages4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistBackgroundImages4QueryOptions(
    playlistPk,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 배경 이미지를 삭제합니다.
 * @summary 배경 이미지 삭제
 */
export const playlistBackgroundImages3 = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${playlistPk}/background-images/${id}/`,
      method: "DELETE",
    },
    options,
  );
};

export const getPlaylistBackgroundImages3MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBackgroundImages3>>,
    TError,
    { playlistPk: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBackgroundImages3>>,
  TError,
  { playlistPk: string; id: string },
  TContext
> => {
  const mutationKey = ["playlistBackgroundImages3"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBackgroundImages3>>,
    { playlistPk: string; id: string }
  > = (props) => {
    const { playlistPk, id } = props ?? {};

    return playlistBackgroundImages3(playlistPk, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBackgroundImages3MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundImages3>>
>;

export type PlaylistBackgroundImages3MutationError = ErrorType<unknown>;

/**
 * @summary 배경 이미지 삭제
 */
export const usePlaylistBackgroundImages3 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBackgroundImages3>>,
      TError,
      { playlistPk: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBackgroundImages3>>,
  TError,
  { playlistPk: string; id: string },
  TContext
> => {
  const mutationOptions = getPlaylistBackgroundImages3MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 저장된 배경 이미지를 api origin으로 스트리밍하여 캔버스 에디터가 CORS taint 없이 로드하게 함.
 * @summary 배경 이미지 바이트 프록시 (캔버스 taint 회피)
 */
export const playlistProxy = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/${id}/proxy/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistProxyQueryKey = (playlistPk?: string, id?: string) => {
  return [
    `/api/playlists/${playlistPk}/background-images/${id}/proxy/`,
  ] as const;
};

export const getPlaylistProxyQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistProxy>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistProxy>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistProxyQueryKey(playlistPk, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playlistProxy>>> = ({
    signal,
  }) => playlistProxy(playlistPk, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(playlistPk && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistProxy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistProxyQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistProxy>>
>;
export type PlaylistProxyQueryError = ErrorType<unknown>;

export function usePlaylistProxy<
  TData = Awaited<ReturnType<typeof playlistProxy>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistProxy>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistProxy>>,
          TError,
          Awaited<ReturnType<typeof playlistProxy>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistProxy<
  TData = Awaited<ReturnType<typeof playlistProxy>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistProxy>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistProxy>>,
          TError,
          Awaited<ReturnType<typeof playlistProxy>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistProxy<
  TData = Awaited<ReturnType<typeof playlistProxy>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistProxy>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 배경 이미지 바이트 프록시 (캔버스 taint 회피)
 */

export function usePlaylistProxy<
  TData = Awaited<ReturnType<typeof playlistProxy>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistProxy>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistProxyQueryOptions(playlistPk, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 여러 배경 이미지를 한 번에 삭제합니다.
 * @summary 이미지 일괄 삭제
 */
export const playlistBulkDelete = (
  playlistPk: string,
  playlistBackgroundImageBulkDeleteRequest: BodyType<PlaylistBackgroundImageBulkDeleteRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/background-images/bulk-delete/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundImageBulkDeleteRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistBulkDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBulkDelete>>,
    TError,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundImageBulkDeleteRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBulkDelete>>,
  TError,
  {
    playlistPk: string;
    data: BodyType<PlaylistBackgroundImageBulkDeleteRequest>;
  },
  TContext
> => {
  const mutationKey = ["playlistBulkDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBulkDelete>>,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundImageBulkDeleteRequest>;
    }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistBulkDelete(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBulkDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBulkDelete>>
>;
export type PlaylistBulkDeleteMutationBody =
  BodyType<PlaylistBackgroundImageBulkDeleteRequest>;
export type PlaylistBulkDeleteMutationError = ErrorType<unknown>;

/**
 * @summary 이미지 일괄 삭제
 */
export const usePlaylistBulkDelete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBulkDelete>>,
      TError,
      {
        playlistPk: string;
        data: BodyType<PlaylistBackgroundImageBulkDeleteRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBulkDelete>>,
  TError,
  {
    playlistPk: string;
    data: BodyType<PlaylistBackgroundImageBulkDeleteRequest>;
  },
  TContext
> => {
  const mutationOptions = getPlaylistBulkDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Flux Kontext Pro를 사용하여 배경 이미지를 생성합니다.

이미지는 바로 저장되지 않고 임시 URL로 반환됩니다.
마음에 드는 이미지를 선택한 후 save-generated 엔드포인트로 저장하세요.

Grooveline 채널의 경우 자동으로 캐릭터 참조 이미지가 포함됩니다.
 * @summary AI 배경 이미지 생성 (미리보기)
 */
export const playlistGenerate2 = (
  playlistPk: string,
  generateBackgroundImageRequest: BodyType<GenerateBackgroundImageRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/background-images/generate/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: generateBackgroundImageRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistGenerate2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistGenerate2>>,
    TError,
    { playlistPk: string; data: BodyType<GenerateBackgroundImageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistGenerate2>>,
  TError,
  { playlistPk: string; data: BodyType<GenerateBackgroundImageRequest> },
  TContext
> => {
  const mutationKey = ["playlistGenerate2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistGenerate2>>,
    { playlistPk: string; data: BodyType<GenerateBackgroundImageRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistGenerate2(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistGenerate2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistGenerate2>>
>;
export type PlaylistGenerate2MutationBody =
  BodyType<GenerateBackgroundImageRequest>;
export type PlaylistGenerate2MutationError = ErrorType<unknown>;

/**
 * @summary AI 배경 이미지 생성 (미리보기)
 */
export const usePlaylistGenerate2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistGenerate2>>,
      TError,
      { playlistPk: string; data: BodyType<GenerateBackgroundImageRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistGenerate2>>,
  TError,
  { playlistPk: string; data: BodyType<GenerateBackgroundImageRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistGenerate2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unsplash/Pexels 사진 페이지 URL을 받아 API로 조회 후 배경 이미지로 저장·출처 기록.
 * @summary 사진 페이지 URL로 스톡 배경 추가
 */
export const playlistImportUrl = (
  playlistPk: string,
  playlistBackgroundImageRequest: BodyType<PlaylistBackgroundImageRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/import-url/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundImageRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistImportUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistImportUrl>>,
    TError,
    { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistImportUrl>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
  TContext
> => {
  const mutationKey = ["playlistImportUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistImportUrl>>,
    { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistImportUrl(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistImportUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistImportUrl>>
>;
export type PlaylistImportUrlMutationBody =
  BodyType<PlaylistBackgroundImageRequest>;
export type PlaylistImportUrlMutationError = ErrorType<unknown>;

/**
 * @summary 사진 페이지 URL로 스톡 배경 추가
 */
export const usePlaylistImportUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistImportUrl>>,
      TError,
      { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistImportUrl>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistImportUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 배경 이미지의 순서를 변경합니다.

image_ids 배열에 이미지 ID를 원하는 순서대로 전달하면 해당 순서로 정렬됩니다.
 * @summary 이미지 순서 변경
 */
export const playlistReorder2 = (
  playlistPk: string,
  playlistBackgroundImageReorderRequest: BodyType<PlaylistBackgroundImageReorderRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/background-images/reorder/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundImageReorderRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistReorder2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistReorder2>>,
    TError,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundImageReorderRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistReorder2>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageReorderRequest> },
  TContext
> => {
  const mutationKey = ["playlistReorder2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistReorder2>>,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundImageReorderRequest>;
    }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistReorder2(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistReorder2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistReorder2>>
>;
export type PlaylistReorder2MutationBody =
  BodyType<PlaylistBackgroundImageReorderRequest>;
export type PlaylistReorder2MutationError = ErrorType<unknown>;

/**
 * @summary 이미지 순서 변경
 */
export const usePlaylistReorder2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistReorder2>>,
      TError,
      {
        playlistPk: string;
        data: BodyType<PlaylistBackgroundImageReorderRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistReorder2>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageReorderRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistReorder2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 미리보기에서 선택한 AI 생성 이미지를 다운로드하여 배경 이미지로 저장합니다.

이미지는 자동으로 2560x1440 WebP로 최적화됩니다.
 * @summary AI 생성 이미지 저장
 */
export const playlistSaveGenerated = (
  playlistPk: string,
  saveGeneratedBackgroundImageRequest: BodyType<SaveGeneratedBackgroundImageRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/save-generated/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: saveGeneratedBackgroundImageRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistSaveGeneratedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistSaveGenerated>>,
    TError,
    { playlistPk: string; data: BodyType<SaveGeneratedBackgroundImageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistSaveGenerated>>,
  TError,
  { playlistPk: string; data: BodyType<SaveGeneratedBackgroundImageRequest> },
  TContext
> => {
  const mutationKey = ["playlistSaveGenerated"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistSaveGenerated>>,
    { playlistPk: string; data: BodyType<SaveGeneratedBackgroundImageRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistSaveGenerated(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistSaveGeneratedMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistSaveGenerated>>
>;
export type PlaylistSaveGeneratedMutationBody =
  BodyType<SaveGeneratedBackgroundImageRequest>;
export type PlaylistSaveGeneratedMutationError = ErrorType<unknown>;

/**
 * @summary AI 생성 이미지 저장
 */
export const usePlaylistSaveGenerated = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistSaveGenerated>>,
      TError,
      {
        playlistPk: string;
        data: BodyType<SaveGeneratedBackgroundImageRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistSaveGenerated>>,
  TError,
  { playlistPk: string; data: BodyType<SaveGeneratedBackgroundImageRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistSaveGeneratedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 검색 결과에서 선택한 스톡 사진을 다운로드·최적화하여 배경 이미지로 저장하고 출처를 기록합니다.
 * @summary 선택한 스톡 사진 저장
 */
export const playlistSaveStock = (
  playlistPk: string,
  playlistBackgroundImageRequest: BodyType<PlaylistBackgroundImageRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/save-stock/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundImageRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistSaveStockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistSaveStock>>,
    TError,
    { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistSaveStock>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
  TContext
> => {
  const mutationKey = ["playlistSaveStock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistSaveStock>>,
    { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistSaveStock(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistSaveStockMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistSaveStock>>
>;
export type PlaylistSaveStockMutationBody =
  BodyType<PlaylistBackgroundImageRequest>;
export type PlaylistSaveStockMutationError = ErrorType<unknown>;

/**
 * @summary 선택한 스톡 사진 저장
 */
export const usePlaylistSaveStock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistSaveStock>>,
      TError,
      { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistSaveStock>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundImageRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistSaveStockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 썸네일/배경용 스톡 사진을 검색합니다. provider=unsplash|pexels.
 * @summary 스톡 사진 검색 (Unsplash/Pexels)
 */
export const playlistSearchStock = (
  playlistPk: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundImage>(
    {
      url: `/api/playlists/${playlistPk}/background-images/search-stock/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistSearchStockQueryKey = (playlistPk?: string) => {
  return [
    `/api/playlists/${playlistPk}/background-images/search-stock/`,
  ] as const;
};

export const getPlaylistSearchStockQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistSearchStock>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSearchStock>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistSearchStockQueryKey(playlistPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistSearchStock>>
  > = ({ signal }) => playlistSearchStock(playlistPk, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!playlistPk,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistSearchStock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistSearchStockQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistSearchStock>>
>;
export type PlaylistSearchStockQueryError = ErrorType<unknown>;

export function usePlaylistSearchStock<
  TData = Awaited<ReturnType<typeof playlistSearchStock>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSearchStock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistSearchStock>>,
          TError,
          Awaited<ReturnType<typeof playlistSearchStock>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistSearchStock<
  TData = Awaited<ReturnType<typeof playlistSearchStock>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSearchStock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistSearchStock>>,
          TError,
          Awaited<ReturnType<typeof playlistSearchStock>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistSearchStock<
  TData = Awaited<ReturnType<typeof playlistSearchStock>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSearchStock>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 스톡 사진 검색 (Unsplash/Pexels)
 */

export function usePlaylistSearchStock<
  TData = Awaited<ReturnType<typeof playlistSearchStock>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSearchStock>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistSearchStockQueryOptions(playlistPk, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
